import { UpperCasePipe } from '@angular/common';
import { Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'am-theme-menu',
  templateUrl: './theme-menu.component.html',
  styleUrls: ['./theme-menu.component.scss'],
  imports: [MatButton, MatMenuTrigger, MatMenu, MatMenuItem, UpperCasePipe],
  standalone: true,
})
export class ThemeMenuComponent implements OnInit {
  availableThemes: string[];

  activeTheme: string;

  private readonly _dom: Document;

  constructor() {
    const document = inject<Document>(DOCUMENT);

    this._dom = document;
  }

  ngOnInit(): void {
    this.availableThemes = ['am-light-theme', 'am-dark-theme', 'am-test-theme'];
    this.activeTheme = 'am-dark-theme';
  }

  themeChange(theme: string): void {
    this._dom.body.classList.replace(this.activeTheme, theme);
    this.activeTheme = theme;
  }
}
